import Cookies from "js-cookie";
import { format, parse, isAfter, isBefore } from "date-fns";

class SpektrixGreeting extends HTMLElement {
    constructor() {
        super();

        this.domain = this.getAttribute("spektrix-domain");
        this.init();
    }

    async init() {
        this.customer = await this.getCustomer();

        this.updateGreeting();

        document.addEventListener(
            "loginSuccess",
            this.handleLoginLogout.bind(this),
        );

        document.addEventListener(
            "logoutSuccess",
            this.handleLoginLogout.bind(this),
        );

        document.addEventListener(
            "sessionUpdate",
            this.handleLoginLogout.bind(this),
        );
    }

    async getCustomer() {
        let sessionCookieData = Cookies.get("spektrix_session");

        sessionCookieData = sessionCookieData
            ? JSON.parse(sessionCookieData)
            : {};

        if (!sessionCookieData.customer) {
            return false;
        }

        return sessionCookieData;
    }

    async updateGreeting() {
        const log_in_container = this.querySelector(
            "[data-logged-in-container]",
        );
        const log_out_container = this.querySelector(
            "[data-logged-out-container]",
        );

        if (this.customer) {
            log_in_container.style.display = "";
            log_out_container.style.display = "none";
            log_in_container.querySelector(
                "[data-logged-in-status-customer-first-name]",
            ).innerHTML = this.customer.firstName;
            const time = SpektrixGreeting.getTimeOfDay();
            log_in_container.querySelector("[time-of-day]").innerHTML = time;
        } else {
            log_out_container.style.display = "";
            log_in_container.style.display = "none";
        }
    }

    static getTimeOfDay() {
        const currentTime = format(new Date(), "HH:mm");

        const morningStart = parse("05:00", "HH:mm", new Date());
        const morningEnd = parse("11:59", "HH:mm", new Date());

        const afternoonStart = parse("12:00", "HH:mm", new Date());
        const afternoonEnd = parse("16:59", "HH:mm", new Date());

        const currentParsedTime = parse(currentTime, "HH:mm", new Date());

        if (
            isAfter(currentParsedTime, morningStart) &&
            isBefore(currentParsedTime, morningEnd)
        ) {
            return "morning";
        } else if (
            isAfter(currentParsedTime, afternoonStart) &&
            isBefore(currentParsedTime, afternoonEnd)
        ) {
            return "afternoon";
        } else {
            return "evening";
        }
    }

    async handleLoginLogout(event) {
        setTimeout(async () => {
            this.customer = await this.getCustomer();
            this.updateGreeting();
        }, 300);
    }
}

customElements.define("spektrix-greeting", SpektrixGreeting);
export default SpektrixGreeting;
